export default "__VITE_ASSET__Uf8Gq0fT__"